<div style="display: flex; width: 100%; height: calc(100% - 10px);">
    <app-guide-container [source]='source'></app-guide-container>
    <app-educational-container (buttonSelectEvent)="returnedSectionTitle($event)" [source]='source' [title]="title"></app-educational-container>
</div>
